<template>
  <div>
    <!-- credit card -->
    <!-- credit card -->
    <vs-popup
      id="credit"
      classContent="popup-example"
      :title="$t('ActivateYourAccount')"
      :active.sync="showCredit"
    >
      <div class="vx-col w-full mb-base">
        <div class="vx-row credit_plan">
          <div class="w-1/2 text-center">
            <strong>{{ $t(plan_name) }}</strong>
          </div>
          <div class="w-1/2 text-center">
            <strong
              ><a @click="changePlan" class="link">{{
                $t("ChangePlan")
              }}</a></strong
            >
          </div>
        </div>
        <div class="back-color text-success mt-5 m-5 p-5">
          <div class="w-full">
            <strong>{{ $t("FreeTrial") }}</strong>
            <br />
            <h6 class="mt-5 text-success">
              <strong>{{ $t("ConfhubPremium") }}</strong>
            </h6>

            <p class="mb-0" v-html="$t('AfterTrial')"></p>

            <p class="mb-0">
              {{ $t("Charged") }}
              <span v-if="expiry_date !== null">{{ expiry_date }}.</span>
            </p>

            <p class="mb-0">{{ $t("OfferTerms") }}</p>
          </div>
        </div>
        <div class="credit_plan mt-5 m-5 p-5">
          <b-button
            variant="link"
            class="float-right link"
            href="javascript:void(0)"
            :title="toolText"
          >
            <strong> {{ $t("PaymentInfo") }} </strong>
          </b-button>
        </div>
        <div class="card-form__inner w-full">
          <div class="mt-5 m-5 p-5">
            <strong for="card-element">{{ $t("CreditorDebitCard") }}</strong>
            <div class="">
              <span
                class="dc_payment_icons_bevel_48 dc_visa02_bevel"
                title="Visa"
              ></span>
              <span
                class="dc_payment_icons_bevel_48 dc_mastercard_bevel"
                title="Mastercard"
              ></span>
              <span
                class="dc_payment_icons_bevel_48 dc_americanexpress_bevel"
                title="American Express"
              ></span>
            </div>
            <!-- <div id="card-element" class="mt-5"></div> -->
            <div class="card-form">
              <div class="">
                <div class="card-input">
                  <label for="cardNumber" class="card-input__label">
                    {{ $t("CardNumber") }}
                    <span class="float-right">
                      <feather-icon
                        icon="LockIcon"
                        svgClasses="h-6 w-6 stroke-current text-grey"
                        class="block"
                    /></span>
                  </label>
                  <b-input
                    v-validate="'required'"
                    :value="cardNumber"
                    autofocus
                    id="cardNumber"
                    name="cardNumber"
                    autocomplete="on"
                    v-model="card"
                    :placeholder="$t('CardNumber')"
                    :data-vv-as="$t('CardNumber')"
                    @change="cardChange"
                    @input="cardInput"
                    onkeypress="return /[0-9]/i.test(event.key)"
                    maxlength="16"
                  />

                  <span id="card" class="text-danger text-sm"></span>
                </div>

                <div class="card-form__row">
                  <div class="card-form__col">
                    <div class="card-form__group">
                      <label for="cardMonth" class="card-input__label">
                        {{ $t("ExpirationDate") }}
                      </label>
                      <div class="w-1/2">
                        <v-select
                          v-validate="'required'"
                          size="large"
                          id="cardMonth"
                          v-model="month"
                          :options="months"
                          name="month"
                          :placeholder="$t('Month')"
                          class="w-full"
                          :data-vv-as="$t('Month')"
                          @input="monthChange"
                        >
                          <template v-slot:option="option">
                            <span :class="option.icon"
                              >{{ option.label }}
                            </span>
                            <feather-icon
                              v-if="month == option.label"
                              icon="CheckIcon"
                              class="float-right"
                              svgClasses="w-5 h-5"
                            />
                          </template>
                        </v-select>

                        <span
                          id="monthExpire"
                          class="text-danger text-sm"
                        ></span>
                      </div>

                      <div class="w-1/2">
                        <v-select
                          size="large"
                          v-validate="'required'"
                          id="cardYear"
                          v-model="year"
                          :options="years"
                          name="year"
                          :placeholder="$t('Year')"
                          class="w-full ml-2"
                          :data-vv-as="$t('year')"
                          @input="yearChange"
                        >
                          <template v-slot:option="option">
                            <span :class="option.icon"
                              >{{ option.label }}
                            </span>
                            <feather-icon
                              v-if="year == option.label"
                              icon="CheckIcon"
                              class="float-right"
                              svgClasses="w-5 h-5"
                            />
                          </template>
                        </v-select>
                        <span
                          id="yearExpire"
                          class="text-danger text-sm ml-2"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="w-1/2">
                  <div class="card-input ml-5">
                    <label for="cardCvv" class="card-input__label">
                      {{ $t("SecurityCode") }}
                      <span class="float-right">
                        <feather-icon
                          :title="$t('SecurityCode')"
                          icon="HelpCircleIcon"
                          svgClasses="h-6 w-6 stroke-current text-grey"
                          class="block" /></span
                    ></label>

                    <b-input
                      id="cardCvv"
                      name="cardCvv"
                      autocomplete="off"
                      v-model="cvv"
                      :placeholder="$t('SecurityCode')"
                      @change="cvvChange"
                      @input="cvvInput"
                      onkeypress="return /[0-9]/i.test(event.key)"
                      maxlength="3"
                    />
                    <span id="cvv" class="text-danger text-sm"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div
                class="w-full ml-5"
                id="subscription"
                style="text-align: justify"
              >
                <!-- <strong>
                  {{ $t("Subscription1") }}
                  <span v-if="expiry_date !== null">{{expiry_date}},</span>
                  {{ $t("Subscription2")
                  }}<a href="javascript:void(0)">{{ $t("Here") }}</a
                  >.
                </strong> -->
                                 <strong>
                  {{ $t("Subscription1") }}
                  <span v-if="expiry_date !== null">{{expiry_date}},</span>
                  {{ $t("Subscription2")
                  }}<router-link to="/company/terms" target="_blank">{{ $t("Here") }}</router-link>.
                </strong>
              </div>
            </div>
            <div
              class="vx-row align-text xs:w-full sm:w-full md:w-full lg:w-full xl:w-full ml-2"
            >
              <div class="w-1/4"></div>
              <div class="w-1/2">
                <b-button
                  variant="primary"
                  @click="submit"
                  id="card-button"
                  class="mt-5"
                >
                  <span v-if="plan_name !== null"
                    >{{ $t("Activate1") }}{{ plan_name
                    }}{{ $t("Plan").toLowerCase() }}</span
                  >
                  <span v-else>{{ $t("Activate") }}</span>
                </b-button>
                <div class="w-1/4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
    <!-- /credit card -->
    <!-- /credit card -->
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import $ from "jquery";
import { getStripeKey } from "@/utils/stripe";

export default {
  props: {
    showCredit: {
      type: Boolean,
    },
  },
  data() {
    return {
      card: "",
      credit_popup: false,
      stripe: "",
      cardNumber: "4242424242424242",
      month: "",
      year: "",
      name: "",
      cvv: "",
      card_id: "",
      plan_name: null,
      expiry_date: null,
      toolText: "",
      todayDate: null,
      createdDate: null,
      diffDate: null,
      close: true,
      currentYear: new Date().getFullYear(),
      months: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      years: [],
      token: "",
    };
  },
  components: {
    "v-select": vSelect,
  },
  mounted() {
    var max = new Date().getFullYear();
    var min = max + 9;
    var years = [];

    for (var i = max; i <= min; i++) {
      years.push(i);
    }
    this.years = years;
    this.loadLocale(this.$i18n.locale);
    this.card_id = this.$store.getters.currentUser.card_id;
    this.todayDate = moment();
    var temp = this.$store.getters.currentUser.created_at;
    this.createdDate = moment(temp);
    this.diffDate = this.todayDate.diff(this.createdDate, "days");
    if (this.diffDate >= 6) {
      this.close = false;
    }
    if (typeof this.$store.getters.currentUser.plan_name !== "string") {
      this.plan_name = null;
    } else {
      this.plan_name =
        this.$store.getters.currentUser.plan_name.charAt(0).toUpperCase() +
        this.$store.getters.currentUser.plan_name.slice(1);
    }

    var expire = this.$store.getters.currentUser.expiry_date;
    if (expire !== null) {
      this.expiry_date = moment(expire).format(" Do of MMMM YYYY");
      this.toolText =
        this.$t("PaymentInfoMessage1") +
        this.expiry_date +
        this.$t("PaymentInfoMessage2");
    }

    if (
      (this.card_id == null ||
        this.card_id == undefined ||
        this.card_id.length == 0) &&
      (this.$store.getters.currentUser.is_postpaid == 0 ||
        this.$store.getters.currentUser.is_postpaid == null)
    ) {
      this.credit_popup = true;
    }
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },
  methods: {
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    cardInput() {
      let card = Stripe.card.validateCardNumber(this.card);
      if (this.card == "") {
        $("#card").text(this.$t("CardRequired"));
        return false;
      } else {
        $("#card").text("");
      }
    },
    cardChange() {
      let card = Stripe.card.validateCardNumber(this.card);
      if (this.card == "") {
        $("#card").text(this.$t("CardRequired"));
        return false;
      } else {
        $("#card").text("");
      }
    },
    cvvInput() {
      let card = Stripe.card.validateCVC(this.cvv);
      if (this.cvv == "") {
        $("#cvv").text(this.$t("SecurityCodeRequired"));
        return false;
      } else {
        $("#cvv").text("");
      }
    },
    cvvChange() {
      let card = Stripe.card.validateCVC(this.cvv);
      if (this.cvv == "") {
        $("#cvv").text(this.$t("SecurityCodeRequired"));
        return false;
      } else {
        $("#cvv").text("");
      }
    },
    monthChange() {
      if (this.month == "" || this.month == null) {
        $("#monthExpire").text(this.$t("MonthRequired"));
      } else {
        $("#monthExpire").text("");
      }
    },
    yearChange() {
      if (this.year == "" || this.year == null) {
        $("#yearExpire").text(this.$t("YearRequired"));
      } else {
        $("#yearExpire").text("");
      }
    },

    /**
     * saveCard
     */
    saveCard(card_id) {
      this.$vs.loading();
      if (card_id) {
        this.$emit("close");
        var data = {
          card_id: card_id,
          company_id: this.$store.getters.currentUser.id,
          card_number: this.card,
          month: this.month,
          year: this.year,
        };
        this.$store
          .dispatch("SaveCard", data)
          .then((res) => {
            console.log("SaveCard-res", res);
            this.credit_popup = false;
            this.$vs.loading.close();
            this.$emit("purchasePlan");
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log("SaveCard-error", error);
            // Error response
            this.$vs.notify({
              title: this.$t("CardFailed"),
              text: error,
              color: "danger",
              position: "top-center",
            });
            return false;
          });
      }
    },

    changePlan() {
      this.$emit("changePlan");
    },

    submit() {
      if (this.cvv == "") {
        $("#cvv").text(this.$t("SecurityCodeRequired"));
      }
      if (this.card == "") {
        $("#card").text(this.$t("CardRequired"));
      } else {
        $("#card").text("");
      }
      if (this.month == "") {
        $("#monthExpire").text(this.$t("MonthRequired"));
      } else {
        $("#monthExpire").text("");
      }
      if (this.year == "") {
        $("#yearExpire").text(this.$t("YearRequired"));
      } else {
        $("#yearExpire").text("");
      }
      if (this.card && this.month && this.year && this.cvv) {
        let card = Stripe.card.validateCardNumber(this.card);
        let cvv = Stripe.card.validateCVC(this.cvv);
        let expiry = Stripe.card.validateExpiry(this.month, this.year);

        if (card !== true) {
          $("#card").text(this.$t("CardInvalid"));
          return false;
        }
        if (cvv !== true) {
          $("#cvv").text(this.$t("CvvInvalid"));
          return false;
        }
      } else {
        return false;
      }

      let instance = this;
      function stripeResponseHandler(status, response) {
        // Grab the form:
        console.log("status-----", status);
        console.log("response-----", response);

        if (response.error) {
          if (response.error.code == "incorrect_number") {
            $("#card").text(this.$t("CardIncorrect"));
            return false;
          }
          if (response.error.code == "card_declined") {
            $("#card").text(this.$t("CardDeclined"));
            return false;
          }

          // Problem!
          if (response.error.code == "invalid_expiry_month") {
            $("#monthExpire").text(this.$t("ExpireMonth"));
            return false;
          }
          if (response.error.code == "invalid_expiry_year") {
            $("#yearExpire").text(this.$t("ExpireYear"));
            return false;
          }
          if (
            response.error.code == "parameter_missing" &&
            response.error.param == "card[exp_month]"
          ) {
            $("#monthExpire").text(this.$t("MonthRequired"));
          }
          if (
            response.error.code == "parameter_missing" &&
            response.error.param == "card[exp_year]"
          ) {
            $("#yearExpire").text(this.$t("YearRequired"));
          }
          console.log("response.error-----------", response.error);
          return false;
        } else {
          // Token was created!

          // Get the token ID:
          instance.token = response.id;
          if (instance.token) this.saveCard(instance.token);
        }
      }
      Stripe.setPublishableKey(getStripeKey());
      Stripe.card.createToken(
        {
          number: this.card,
          cvc: this.cvv,
          exp_month: this.month,
          exp_year: this.year,
        },
        stripeResponseHandler.bind(this)
      );
    },
  },
};
</script>

<style scoped lang="scss">
a {
  text-decoration: underline !important;
}
.card-container {
  margin: 30px auto 50px auto;
}
#card-button {
  white-space: nowrap;
}
.vx-row {
  margin-top: 10px !important;
}

.card-form {
  max-width: 570px;
  margin: auto;
  width: 100%;

  &__inner {
    background: #fff;
    box-shadow: 0 30px 60px 0 rgba(90, 116, 148, 0.4);
    border-radius: 10px;
    padding: 20px;
  }

  &__row {
    display: flex;
    align-items: flex-start;
  }

  &__col {
    flex: auto;
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }

    &.-cvv {
      max-width: 150px;
    }
  }

  &__group {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    .card-input__input {
      flex: 1;
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__button {
    width: 100%;
    height: 55px;
    background: #38a294;
    border: none;
    border-radius: 5px;
    font-size: 22px;
    font-weight: 500;
    box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
    color: #fff;
    margin-top: 20px;
    cursor: pointer;

    &:hover {
      background: darken(#38a294, 5%);
    }
  }
}

.card-input {
  margin-bottom: 20px;
  &__label {
    margin-bottom: 5px;
    color: #1a3b5d;
    width: 100%;
    display: block;
    text-align: left;
  }
  &__input {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    box-shadow: none;
    border: 1px solid #ced6e0;
    transition: all 0.3s ease-in-out;
    font-size: 18px;
    padding: 5px 15px;
    background: none;
    color: #1a3b5d;

    &:hover,
    &:focus {
      border-color: #38a294;
    }

    &:focus {
      box-shadow: 0px 10px 20px -13px rgba(32, 56, 117, 0.35);
    }
    &.-select {
      -webkit-appearance: none;
      background-image: url("/img/select.png");
      background-size: 12px;
      background-position: 90% center;
      background-repeat: no-repeat;
      padding-right: 30px;
    }
    #subscription {
      text-align: justify !important;
    }
  }
}
.back-color {
  background-color: rgb(170, 247, 219);
}
</style>  